import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Api/api';
import { getAuthToken } from '../../Api/authToken';
import './AdminPages.css';

const formatTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
};

const ChatNotifications = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const partner = pathname.startsWith('/partner');
  const [items, setItems] = useState([]);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const url = partner
          ? `${API_URL}/admin/chat/mine/notifications`
          : `${API_URL}/admin/chat/notifications`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        });
        if (cancelled) return;
        setDenied(false);
        setItems(Array.isArray(res.data?.items) ? res.data.items : []);
      } catch (error) {
        if (!cancelled && error.response?.status === 403) setDenied(true);
      }
    };
    load();
    const timer = setInterval(load, 8000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [partner]);

  const openItem = (item) => {
    if (partner) {
      navigate('/partner/chat');
      return;
    }
    navigate(`/admin/chat?thread=${item.id}`);
  };

  return (
    <div className="admin-page">
      <div className="page-header">
        <h1>Chat Notifications</h1>
        <p>{partner ? 'Replies from the admin team.' : 'Unread visitor chats.'}</p>
      </div>
      <div className="admin-card" style={{ padding: '1rem' }}>
        {denied && <p>Chat access is not enabled for this account.</p>}
        {!denied && items.length === 0 && <p>No new chat messages.</p>}
        {!denied && items.map((item) => (
          <button
            type="button"
            key={item.id}
            onClick={() => openItem(item)}
            style={{
              display: 'flex',
              width: '100%',
              textAlign: 'left',
              gap: '12px',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 8px',
              border: 'none',
              borderBottom: '1px solid var(--admin-border, #e2e8f0)',
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            <span>
              <strong style={{ display: 'block' }}>{item.name || 'Chat'}</strong>
              <span style={{ color: 'var(--admin-text-muted, #64748b)', fontSize: '0.875rem' }}>{item.preview || 'New message'}</span>
            </span>
            <span style={{ color: 'var(--admin-text-muted, #64748b)', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
              {formatTime(item.at)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatNotifications;
